export interface NavItem {
  /** Router path. */
  path: string;
  /** Sidebar label. */
  label: string;
  /** Page title shown in the TopBar / DashboardLayout. */
  title: string;
}

export const NAV_ITEMS: NavItem[] = [
  { path: "/", label: "Overview", title: "Overview" },
  { path: "/vault", label: "Vault", title: "The Vault" },
  { path: "/prompts", label: "Prompts", title: "Prompts" },
  { path: "/rituals", label: "Ritual", title: "The Ritual" },
  { path: "/projects", label: "Projects", title: "Projects" },
  { path: "/subscribers", label: "Subscribers", title: "Newsletter subscribers" },
  { path: "/settings", label: "Settings", title: "Settings" },
];

/** Title for the given pathname, falling back to the Overview title. */
export function titleForPath(pathname: string): string {
  return NAV_ITEMS.find((item) => item.path === pathname)?.title ?? NAV_ITEMS[0]!.title;
}
